import React from 'react';
import { TextField, Box, Typography } from '@mui/material';

const LabeledTextarea = ({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  disabled = false,
  maxLength = null,
  minLength = null,
  autosize = true,
  minRows = 2,
  maxRows = 4,
  error = null
}) => {
  const getValidationError = () => {
    if (!value) return null;
    
    if (minLength && value.length < minLength) {
      return `최소 ${minLength}자 이상 입력해주세요`;
    }
    
    if (maxLength && value.length > maxLength) {
      return `최대 ${maxLength}자까지 입력 가능합니다`;
    }
    
    return null;
  };

  const validationError = getValidationError();
  const displayError = error || validationError;

  return (
    <Box>
      <Typography 
        variant="body1"
        style={{
          fontSize: "16px",
          fontWeight: 500,
          marginBottom: "8px",
          color: "inherit"
        }}
      >
        {label}
        {maxLength && (
          <span style={{ color: '#666', fontSize: '14px', marginLeft: '8px' }}>
            ({value ? value.length : 0}/{maxLength})
          </span>
        )}
      </Typography>
      <TextField
        size="medium"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={!!displayError}
        helperText={displayError}
        inputProps={{ maxLength: maxLength }}
        fullWidth
        multiline
        rows={autosize ? undefined : minRows}
        maxRows={autosize ? maxRows : undefined}
        minRows={autosize ? minRows : undefined}
        variant="outlined"
        InputProps={{
          style: {
            fontSize: "16px"
          }
        }}
      />
    </Box>
  );
};

export default LabeledTextarea; 